module.exports = __webpack_public_path__ + "img/ИФ-1(А)-021.315eb7ac.png";